/** The refusal reason to display while the given status is Rejected, otherwise undefined. */
export function shownRefusalReason(donation) {
    return donation.status === "Rejected" ? (donation.paymentRefusalReason ?? undefined) : undefined;
}
// Record (not the array below) is what forces a compile error if a DonationStatus member is
// added/removed without updating this list.
const DONATION_STATUS_MEMBERS = {
    Promesse: true,
    Recorded: true,
    Validated: true,
    Rejected: true,
    Canceled: true,
    Refunded: true,
};
/** Runtime mirror of {@link DonationStatus} — used to validate values that arrive as untyped
 *  strings (e.g. the transitions API). Derived from DONATION_STATUS_MEMBERS, which is what
 *  actually enforces staying in sync. */
export const DONATION_STATUSES = Object.keys(DONATION_STATUS_MEMBERS);
/** Type guard: true when `value` is a real DonationStatus member. */
export function isDonationStatus(value) {
    return value in DONATION_STATUS_MEMBERS;
}
// Record (not a Set) so adding a DonationStatus member without deciding whether it is deletable
// is a compile error rather than a silently-undeletable donation.
const DONATION_STATUS_ALLOWS_DELETION = {
    Promesse: true,
    Recorded: true,
    Validated: false,
    Rejected: true,
    Canceled: true,
    Refunded: false,
};
/** Deletion rule, same as OPDON's server-side guard: a donation is deletable only while
 *  its status leaves no financial trace (Recorded, Promesse, Rejected, Canceled) AND no tax
 *  receipt was ever issued for it — a cancelled receipt is kept on record and still counts.
 *  Returns the blocker to explain in the M-E-01 modal, or `null` when the deletion may proceed.
 *  The status is reported first when both apply (the receipt follows from the status). */
export function getDonationDeletionBlocker(status, hasTaxReceipt) {
    if (!DONATION_STATUS_ALLOWS_DELETION[status])
        return "StatusLocked";
    if (hasTaxReceipt)
        return "TaxReceiptLinked";
    return null;
}
